import TempAccountMessageRegulationHelper from "../../../helpers/temp_account_message_helper";
import {CGP_ERROR_CODES} from "../../../../../exceptions/cgp_error_codes";
import {REGULATION_CODE_TYPES} from '../../../regulation_const';
import USBaseRegulation from '../us_base_regulation';


export default class NewJerseyRegulation extends USBaseRegulation {

    static CLASS = 'NewJerseyRegulation';

    protected _getRegulationType(): number {
        return REGULATION_CODE_TYPES.NJ;
    }

    showTempAccountMessage() {
        TempAccountMessageRegulationHelper.create({
            serviceFactory: this.serviceFactory
        }).showTempAccountMessage({
            messageKey: 'nj_temp_account_message'
        });
    }

    forceHideCloseButtonInMembership() {
        return true;
    }

    /**
     * This hook has comment due to using of logoutUser() at "new-jersey.regulation.ts".
     * Using this will cause NJ to use CGP modal instead of dialog service!
     * Beware: if both hooks are in use, user will see two same popups at logout.
     */
    // showLogoutMessage() {
    //     this.serviceFactory.messageManagerService().openMessage({
    //         text: this.serviceFactory.languageService().translation('logout_message_text'),
    //         title: this.serviceFactory.languageService().translation('logout_message_title'),
    //         customCSSClassList: ['cgp-mdp-text-support-slash-n'],
    //         hasDefaultButton: false,
    //         buttons: [
    //             {
    //                 name: this.serviceFactory.languageService().translation('mdp_ok'),
    //                 isClosable: true
    //             }
    //         ]
    //     });
    // }

    getErrorMessage(errorCode) {
        errorCode = errorCode.toString();
        if(errorCode === CGP_ERROR_CODES.TIME_LIMIT_REACHED_DAILY.toString()) {
            return this.serviceFactory.languageService().translation(CGP_ERROR_CODES.TIME_LIMIT_REACHED_DAILY + '_nj');
        }

        return super.getErrorMessage(errorCode);
    }
}
